import { reactive } from 'vue'

/**
 * Coordinates the "sudo" re-auth prompt. When a request fails with 403 `sudo_required`, the api interceptor
 * calls requireSudo() (which surfaces the SudoDialog); the dialog re-confirms identity via POST /auth/sudo
 * and resolves the promise, after which the interceptor retries the original request.
 */
export const sudoState = reactive({
  active: false,
  error: '',
  _resolve: null,
  _reject: null,
})

export const requireSudo = () =>
  new Promise((resolve, reject) => {
    sudoState.active = true
    sudoState.error = ''
    sudoState._resolve = resolve
    sudoState._reject = reject
  })

/** Called by SudoDialog after a successful POST /auth/sudo. */
export const resolveSudo = () => {
  const resolve = sudoState._resolve
  sudoState.active = false
  sudoState._resolve = null
  sudoState._reject = null
  resolve?.()
}

/** Called when the user cancels the prompt. */
export const cancelSudo = () => {
  const reject = sudoState._reject
  sudoState.active = false
  sudoState._resolve = null
  sudoState._reject = null
  reject?.(new Error('sudo_cancelled'))
}
